import api from './api';

const fetchAreas = async ({ params, headers }) => {
  const response = await api.get({ url: 'v2/area', params, headers });
  return response;
};

const fetchAreasWithParams = (functionArgs = {}) => {
  const { params, headers } = functionArgs;
  return async () => {
    const requestObject = { url: 'v2/area' };
    if (params) requestObject.params = params;
    if (headers) requestObject.headers = params;
    const response = await api.get(requestObject);
    return response;
  };
};

export { fetchAreas, fetchAreasWithParams };
